import { jsxs, jsx } from "react/jsx-runtime";
import { ListItem as ListItem$1, token, IconCheckmark } from "@zillow/constellation";
import PropTypes from "prop-types";
import { useContext } from "react";
import styled from "styled-components";
import { ListContext } from "./ListContext.esm.js";
const StyledListItem = styled(ListItem$1).withConfig({
  displayName: "ListItem__StyledListItem",
  componentId: "sc-szgmns-0"
})(["", " &::marker{color:", ";}&&&&{padding-top:0;}&:last-child{padding-bottom:0;}"], (props) => props.appearance === "checkmark" ? `
        position: relative;
    ` : "", (props) => props.adornmentColor ? token(`colors.${props.adornmentColor}`) : "inherit");
const StyledIconCheckmark = styled(IconCheckmark).withConfig({
  displayName: "ListItem__StyledIconCheckmark",
  componentId: "sc-szgmns-1"
})(["position:absolute;top:0;left:-", "px;color:", ";"], token("spacing.lg"), (props) => props.adornmentColor ? token(`colors.${props.adornmentColor}`) : "inherit");
const ListItem = (props) => {
  const {
    appearance,
    verticalSpace,
    adornmentColor
  } = useContext(ListContext);
  return /* @__PURE__ */ jsxs(StyledListItem, { appearance, paddingBottom: verticalSpace, adornmentColor, ...props, children: [
    appearance === "checkmark" && /* @__PURE__ */ jsx(StyledIconCheckmark, { size: "sm", adornmentColor }),
    props.children
  ] });
};
ListItem.propTypes = {
  children: PropTypes.shape({})
};
export {
  ListItem as default
};
